import {
  addressSchema,
  titleUI,
  yesNoSchema,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import SponsorAddressPrefillCard from '../../components/FormDescriptions/SponsorAddressPrefillCard';
import SponsorAddressPrefillReview from '../../components/FormReview/SponsorAddressPrefillReview';
import content from '../../locales/en/content.json';
import { hiddenFieldUI } from '../../definitions';
import { ADDRESS_CONFIRM_KEY } from '../../utils/helpers';

const TITLE_TEXT = content['sponsor--prefill-address-title'];
const DESC_TEXT = content['sponsor--prefill-address-description'];
const INPUT_LABEL = content['sponsor--prefill-address-label'];

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    'ui:description': SponsorAddressPrefillCard,
    'ui:objectViewField': SponsorAddressPrefillReview,
    [ADDRESS_CONFIRM_KEY]: yesNoUI(INPUT_LABEL),
    sponsorAddress: hiddenFieldUI,
  },
  schema: {
    type: 'object',
    required: [ADDRESS_CONFIRM_KEY],
    properties: {
      [ADDRESS_CONFIRM_KEY]: yesNoSchema,
      sponsorAddress: addressSchema(),
    },
  },
};
